// extracted by mini-css-extract-plugin
export const actionButton = "TransactionRowMobile__actionButton__6SkcB";
export const atlasGrotesk = "'AtlasGrotesk'";
export const bold = "700";
export const category = "TransactionRowMobile__category__-4a6k";
export const categoryCopy = "TransactionRowMobile__categoryCopy__CsAfL";
export const description = "TransactionRowMobile__description__Y4ErG";
export const headBgColorExternal = "var(--salt)";
export const headBgColorInternal = "var(--shade)";
export const headBgColorShrunkSidebar = "var(--slate)";
export const medium = "500";
export const regular = "400";
export const right = "TransactionRowMobile__right__8Y0Fk";
export const sans = "'sans'";
export const semibold = "600";
export const serif = "'serif'";
export const textCenter = "TransactionRowMobile__textCenter__ZKBnv";
export const tooltipIconWrapper = "TransactionRowMobile__tooltipIconWrapper__XUQJT";
export const tooltipIconWrapperOuter = "TransactionRowMobile__tooltipIconWrapperOuter__jV1FI";